<template>
    <div>
        <el-page-header @back="$router.go(-1)" content="精准关怀体检说明" />
        <div class="checkup-standard-container">
            <div>
                <img src="./widgets/jingzhunguanhuai2.png" alt="" style="width: 100%; height: auto;max-width: 2000px;">
            </div>
            <el-card shadow="hover">
                <div slot="header" class="header-title">
                    <span>精准关怀体检项目执行标准</span>
                </div>

                <el-table :data="tableData" border style="width: 100%" :span-method="objectSpanMethod"
                    header-cell-class-name="table-header">
                    <el-table-column prop="category" label="类别" width="180" align="center"></el-table-column>

                    <el-table-column label="体检项目">
                        <template slot-scope="scope">
                            <div :class="{ 'highlight-row': scope.row.isHighlight }">
                                <p class="project-content">{{ scope.row.content }}</p>
                                <p v-if="scope.row.note" class="project-note">注：{{ scope.row.note }}</p>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="price" label="价格(元)" width="220" align="center"></el-table-column>
                </el-table>

                <div class="footer-info">
                    <p>2026年1月</p>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'keycare_index',
    path: '/main/keycare/index',
    meta: {
        title: '精准关怀体检说明',
    },
    data() {
        return {
            loading: false,
            tableData: [
                {
                    category: "心血管疾病风险筛查",
                    content: "颈动脉狭窄≥50%，建议进一步行 头颈、冠脉二合一CTA检查",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行",
                    isHighlight: false
                },
                {
                    category: "心血管疾病风险筛查",
                    content: "有临床症状+颈动脉斑块，且合并以下三项高危因素：室间隔增厚、左室增大、血糖升高、BMI ≥ 28、血压偏高、血脂异常、男性年龄≥45，建议行冠脉CTA检查",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行",
                    isHighlight: false
                },
                {
                    category: "心血管疾病风险筛查",
                    content: "心电图提示：心电图提示：1.显著心动过缓，2.频发早搏，3.二度以上窦房或房室传导阻滞，经专家研判建议行24小时动态心电检查。",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行",
                    isHighlight: false // 对应图片中的黄色高亮
                },
                {
                    category: "脑血管疾病风险筛查",
                    content: "有颈动脉斑块且合并以下三项高危因素：室间隔增厚、左室增大、血糖升高、BMI ≥ 24、血压偏高、血脂异常、男性年龄≥45、重度动脉硬化，建议行颅脑核磁MRA检查",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行",
                    note: "员工2024、2025年完成CTA、MRA检查的，原则上2026年不再检查；特殊需要的，须经专家研判确定、体检机构线上提交，由员工所属单位审核并备案。"
                },
                {
                    category: "肺癌风险筛查",
                    content: "有实性结节或部分实性结节的实性成分，平均直径≥6mm且＜15mm，或非实性结节平均直径≥8mm且＜15mm者，建议行肺小结节肿瘤分析",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行"
                },
                {
                    category: "肺癌风险筛查",
                    content: "有实性结节、部分实性结节的实性成分或非实性结节平均直径≥15mm，如无法排除恶性结节，建议常规抗炎治疗后1~3个月行肺小结节肿瘤分析",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行"
                },
                {
                    category: "乳腺癌风险筛查",
                    content: "有乳腺B超检查结果显示为BI-RADS 4类及以上时，经专家研判建议行乳腺钼靶检查",
                    price: "依据《大庆市公立医疗机构医疗服务项目价格（2026年）》执行"
                },
            ]
        }
    },
    methods: {
        // 合并单元格逻辑
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            // 合并第一列（类别）
            if (columnIndex === 0) {
                if (rowIndex === 0) return [3, 1];
                if (rowIndex === 1 || rowIndex === 2) return [0, 0];
                if (rowIndex === 4) return [2, 1];
                if (rowIndex === 5) return [0, 0];
            }
            // 合并第三列（价格）
            if (columnIndex === 2) {
                if (rowIndex === 0) return [7, 1];
                if (rowIndex >= 1 && rowIndex <= 6) return [0, 0];
                if (rowIndex === 7) return [1, 1];
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.checkup-standard-container {
    margin: 20px auto;
    padding: 0px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.header-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #303133;
}

.table-header {
    background-color: #eef5e9 !important;
    color: #333;
    font-weight: bold;
}

.project-content {
    line-height: 1.6;
    font-size: 14px;
    white-space: pre-line;
}

.project-note {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
    padding: 8px;
    border-top: 1px dashed #dcdfe6;
}

.highlight-row {
    background-color: #fffde7;
    margin: -10px;
    padding: 10px;
}

.footer-info {
    margin-top: 20px;
    text-align: right;
    color: #909399;
    font-size: 14px;
}
</style>